import React, { useState } from 'react';
import { TextField } from 'office-ui-fabric-react';
import { RichTextField } from '../../../../components/RichTextField';
import {
  FIELDTYPE_BODYINFORMATION,
  FIELDTYPE_CONCLUSION,
  FIELDTYPE_ESDH_TITLE,
  FIELDTYPE_TITLE,
} from '../../../../constants/api';

export const FieldTemplatePanelTextField = ({
  translator,
  fieldTypeEnum,
  onTextChange,
  value,
  maxLength,
}) => {
  const [initialValue] = useState(value);

  const renderTextField = () => {
    switch (fieldTypeEnum) {
      case FIELDTYPE_TITLE:
      case FIELDTYPE_ESDH_TITLE:
        return (
          <div style={{ paddingTop: '25px' }}>
            <TextField
              label={translator('pages.adminFieldTemplates.panelTextLabel')}
              multiline={3}
              onChange={(_, value) => onTextChange(value)}
              placeholder={translator(
                'pages.adminFieldTemplates.panelTextPlaceholder',
              )}
              defaultValue={initialValue}
              maxLength={maxLength}
            />
          </div>
        );
      case FIELDTYPE_BODYINFORMATION:
      case FIELDTYPE_CONCLUSION:
        return (
          <div style={{ paddingTop: '25px' }}>
            <RichTextField
              initialValue={initialValue}
              label={translator('pages.adminFieldTemplates.panelTextLabel')}
              onChange={(value) => onTextChange(value)}
              placeholder={translator(
                'pages.adminFieldTemplates.panelTextPlaceholder',
              )}
              maxLength={maxLength}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return <div>{renderTextField()}</div>;
};
